import { useCallback, useMemo, useState } from "react";
import NotificationContext from "./NotificationContext";
import AppSnackbar from "components/notifications/AppSnackbar";

export default function NotificationProvider({ children }) {
    const [notification, setNotification] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const close = useCallback(() => {
        setNotification((prev) => ({
            ...prev,
            open: false
        }));
    }, []);

    const show = useCallback((message, severity = "success") => {
        setNotification({
            open: true,
            message,
            severity
        });
    }, []);

    const value = useMemo(
        () => ({
            success: (message) => show(message, "success"),
            error: (message) => show(message, "error"),
            warning: (message) => show(message, "warning"),
            info: (message) => show(message, "info")
        }),
        [show]
    );

    return (
        <NotificationContext.Provider value={value}>
            {children}

            <AppSnackbar
                open={notification.open}
                message={notification.message}
                severity={notification.severity}
                onClose={close}
            />
        </NotificationContext.Provider>
    );
}
